export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const DEFAULT_PAGINATION = DEFAULT_PAGE_SIZE_OPTIONS[0];

const MAX_EXPORT_ROWS = 10000;

export const fetchAllPages = async (fetcher, filters = {}, options = {}) => {
  const {pageSize = DEFAULT_PAGE_SIZE_OPTIONS[DEFAULT_PAGE_SIZE_OPTIONS.length - 1], maxRows = MAX_EXPORT_ROWS} =
    options;

  const rows = [];
  let page = 0;

  while (rows.length < maxRows) {
    const response = await fetcher({...filters, page, limit: pageSize});
    const pageRows = response?.data?.data;

    if (!Array.isArray(pageRows) || pageRows.length === 0) break;

    rows.push(...pageRows);

    const totalItems = response?.data?.pagination?.totalItems;
    if (pageRows.length < pageSize || (totalItems && rows.length >= totalItems)) break;

    page += 1;
  }

  return rows.slice(0, maxRows);
};
